import React from 'react';
import { IconProps } from '.';

const SvgArrowTop = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        d='M4 5.25h16v-1.5H4v1.5ZM12 7.94l-7.53 7.53 1.06 1.06L12 10.06l6.47 6.47 1.06-1.06L12 7.94Z'
      />
    </svg>
  );
};

export default SvgArrowTop;
